/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatRespVariantLazy_viewer">;
    readonly " $refType": "PdpRespDealerChatLoader_viewer";
};
export type PdpRespDealerChatLoader_viewer$data = PdpRespDealerChatLoader_viewer;
export type PdpRespDealerChatLoader_viewer$key = {
    readonly " $data"?: PdpRespDealerChatLoader_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLoader_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isInteractivePdpChat"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerChatLoader_viewer",
  "selections": [
    {
      "condition": "isInteractivePdpChat",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuyerChatRespVariantLazy_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '3ead5e16c9327b4dca6168febabc5564';
export default node;
